import './less/whatsapp.less';

export default function () {

}


// WEBPACK FOOTER //
// ./components/whatsapp/whatsapp.js